import React, {useEffect} from 'react';

import {setWindowTitle} from 'BenchlingUtil';
import {Header1} from 'ui-library/Headers';

import ParameterLibraryListing from './ParameterLibraryListing';

export default function ParameterLibraryPage(): JSX.Element {
  useEffect(() => {
    setWindowTitle('Parameter library');
  }, []);

  return (
    <div className="settingsPage">
      <div className="settingsPage-contentWrapper">
        <Header1>Parameter library</Header1>
        <ParameterLibraryListing />
      </div>
    </div>
  );
}
